module.exports = __webpack_public_path__ + "img/astroWhackerLogo.74fcbf8d.png";